module.exports = __webpack_public_path__ + "static/media/5045_1100315940646_63739_n.2c87dbe1.jpg";